/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class Enterprise extends Mb {
    constructor() {
        super();
        this.baseUrl += '/enterprise';
    }

    data({
        settlementRulesName,
        enterpriseSn,
        enterpriseName,
        userName,
        fullName,
        mobile,
        isAvailable,
        insertTime,
        schoolOrgId,
        enterpriseStatus,
        enterpriseAuthority,
        currentPage,
        pageSize,
    } = {}) {
        let insertBeginTime = null;
        let insertEndTime = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertBeginTime, insertEndTime] = insertTime;
        }
        return super.get('/data', {
            settlementRulesName,
            enterpriseSn,
            enterpriseName,
            userName,
            fullName,
            mobile,
            isAvailable,
            insertBeginTime,
            insertEndTime,
            schoolOrgId,
            enterpriseStatus,
            enterpriseAuthority,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({
        id,
        enterpriseSn,
        enterpriseName,
        principalName,
        principalTel,
        principalEmail,
        socialCreditCode,
        regionId,
        address,
        remarks,
        memberId,
        isAvailable,
        schoolOrgId,
        enterpriseAuthority,
        billCompanyName,
        billCompanyCode,
        billCompanyAddress,
        billCompanyTel,
        billBankAccount,
        billBankName,
    } = {}) {
        return super.post('/save', {
            id,
            enterpriseSn,
            enterpriseName,
            principalName,
            principalTel,
            principalEmail,
            socialCreditCode,
            regionId,
            address,
            remarks,
            memberId,
            isAvailable,
            schoolOrgId,
            enterpriseAuthority,
            billCompanyName,
            billCompanyCode,
            billCompanyAddress,
            billCompanyTel,
            billBankAccount,
            billBankName,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }

    status({ id, isAvailable } = {}) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    validatorEnterpriseName({ id, enterpriseName } = {}) {
        return super.get('/validatorEnterpriseName', {
            id,
            enterpriseName,
        });
    }

    submit({ id, enterpriseStatus, auditOpinion } = {}) {
        return super.post('/submit', {
            id,
            enterpriseStatus,
            auditOpinion,
        });
    }

    applyMaterialsDetail({ enterpriseId, applyMaterialsId }) {
        return super.get('/applyMaterialsDetail', { enterpriseId, applyMaterialsId });
    }

    saveApplyMaterials({ enterpriseId, applyMaterialsId, applyMaterialsValue }) {
        return super.post('/saveApplyMaterials', { enterpriseId, applyMaterialsId, applyMaterialsValue });
    }
}

export default new Enterprise();
export { Enterprise };
